<template>
  <HeaderComponent />
  <router-view />
  <FooterComponent :showSocials="showSocials" />
</template>

<script setup lang="ts">
import FooterComponent from '@/components/FooterComponent.vue';
import HeaderComponent from '@/components/HeaderComponent.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const showSocials = computed(() => (route.meta.showSocials as boolean) ?? false);
</script>
